module.exports = __webpack_public_path__ + "img/logo-emil-frey-use-case.5ff2c707.webp";